import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function RouteListener({ onRouteChange }) {
  const location = useLocation();
  const prevLocation = usePrevious(location);

  useEffect(() => {
    onRouteChange(location, prevLocation);
  }, [location]);

  return null;
}

RouteListener.propTypes = {
  onRouteChange: PropTypes.func.isRequired
};

export default RouteListener;
